export enum Colors {
  RED = 'red',
  TERRACOTTA = 'terracotta',
  VIOLET = 'violet',
  DARKVIOLET = 'darkviolet',
  YELLOW = 'yellow',
  LAKE = 'lake',
  DARKLAKE = 'darklake',
  GREY = 'grey',
  WHITE = 'white'  
};

export enum Sizes {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large'
};

export enum Targets {
  SELF = '_self',
  BLANK = '_blank',
};

export enum Themes {
  DARK = 'dark',
  LIGHT = 'light',
  WHITE = 'white'
}